import { useContext } from 'react';
import styles from './Card.module.css';
import { useTranslation } from 'react-i18next';
import { TabContext } from '../../../../../Context/TabContext';
import Indicator from '../../../../UI/Indicator/Indicator';
import { formatDateFromDB } from '../../../../../../utils/FormatDate';

const CardKlijenti = ({
  machine,
  handleOpenDetalView,
  handleIzmeni,
  handleDelete,
  handleDodajDelove,
  handleOpenDocumentView,
}) => {
  const { t, i18n } = useTranslation();
  const { addTab } = useContext(TabContext);
  const handleNewService = (item) => {
    const tab = {
      title: 'Novi zahtev za servis',
      icon: 'fas fa-toolbox',
      type: 10010,
      data: item,
    };
    addTab(tab);
  };
  const handleOrderOverview = (item) => {
    const tab = {
      title: 'Naručeni delovi',
      icon: 'fas fa-toolbox',
      type: 10021,
      data: item,
    };
    addTab(tab);
  };

  return (
    <div className={styles.card} onClick={handleOpenDetalView}>
      <Indicator
        outerStyle={{ height: '28px', width: '28px' }}
        innerStyle={{}}
        status={machine.status}
        active={machine.status === 'Operativna'}
      />
      <img src={machine.slikaUrl} alt="Machine" className={styles.image} />
      <h2>
        {/* {machine.tipMasine === ''
          ? ''
          : machine.tipMasine === 'Robot'
          ? t('robotTag')
          : t('moldTag')}{' '} */}
        {machine.oznakaKupac}
      </h2>
      <p>
        {t('Tag')} {machine.sifra}
      </p>
      <p>
        {t('machineType')}: {machine.tipMasine}
      </p>
      {/* <p>{machine.naziv}</p> */}
      <p style={{ fontWeight: 'bold' }}>
        {t('endOfWarrany')}: {formatDateFromDB(machine.garancijaIstice)}
      </p>
      <div className={styles.buttons}>
        {/* <button
          onClick={(e) => handleIzmeni(e, machine)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-edit ${styles.icon}`} />
          {t('editMachine')}
        </button> */}
        {/* <button
          onClick={(e) => handleDodajDelove(e, machine)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-cog ${styles.icon}`} />
          {t('addParts')}
        </button> */}
        <button
          onClick={() => handleNewService(machine)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-plus ${styles.icon}`} />
          {t('newServiceRequest')}
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleOpenDocumentView();
          }}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-file ${styles.icon}`} />
          {t('documentation')}
        </button>
        <button
          onClick={() => handleOrderOverview(machine)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-list-alt ${styles.icon}`} />
          {t('orderOverview')}
        </button>

        {/* <button
          onClick={(e) => handleDelete(e, machine)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-trash-alt ${styles.icon}`} />
          {t('deleteMachine')}
        </button> */}
      </div>
    </div>
  );
};

export default CardKlijenti;
